export * from './declaracao-de-domicilio';